<template>
  <!-- Experienced Course Five -->
  <section class="experienced-course-five">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6" data-aos="fade-down">
          <div class="experienced-five-group">
            <div class="instructor-vector-left">
              <img src="@/assets/img/bg/instructor-vector-left.svg" alt="Img" />
            </div>
            <div class="developer-five-list">
              <ul>
                <li class="column-img">
                  <div class="developer-profile-five">
                    <div class="developer-image">
                      <img src="@/assets/img/user/user-01.jpg" alt="Course Instructor" />
                    </div>
                    <div class="profile-five-ovelay">
                      <h5>Daziy Millar</h5>
                      <p>PHP Expert</p>
                    </div>
                  </div>
                </li>
                <li class="column-img">
                  <div class="developer-profile-five">
                    <div class="developer-image">
                      <img src="@/assets/img/user/user-02.jpg" alt="Course Instructor" />
                    </div>
                    <div class="profile-five-ovelay">
                      <h5>Daziy Millar</h5>
                      <p>PHP Expert</p>
                    </div>
                  </div>
                </li>
                <li class="column-img">
                  <div class="developer-profile-five">
                    <div class="developer-image">
                      <img src="@/assets/img/user/user-03.jpg" alt="Course Instructor" />
                    </div>
                    <div class="profile-five-ovelay">
                      <h5>Daziy Millar</h5>
                      <p>PHP Expert</p>
                    </div>
                  </div>
                </li>
                <li class="column-img">
                  <div class="developer-profile-five">
                    <div class="developer-image">
                      <img src="@/assets/img/user/user-04.jpg" alt="Course Instructor" />
                    </div>
                    <div class="profile-five-ovelay">
                      <h5>Daziy Millar</h5>
                      <p>PHP Expert</p>
                    </div>
                  </div>
                </li>
                <li class="column-img">
                  <div class="developer-profile-five">
                    <div class="developer-image">
                      <img src="@/assets/img/user/user-05.jpg" alt="Course Instructor" />
                    </div>
                    <div class="profile-five-ovelay">
                      <h5>Daziy Millar</h5>
                      <p>PHP Expert</p>
                    </div>
                  </div>
                </li>
                <li class="column-img">
                  <div class="developer-profile-five">
                    <div class="developer-image">
                      <img src="@/assets/img/user/user-06.jpg" alt="Course Instructor" />
                    </div>
                    <div class="profile-five-ovelay">
                      <h5>Daziy Millar</h5>
                      <p>PHP Expert</p>
                    </div>
                  </div>
                </li>
                <li class="column-img">
                  <div class="developer-profile-five">
                    <div class="developer-image">
                      <img src="@/assets/img/user/user-07.jpg" alt="Course Instructor" />
                    </div>
                    <div class="profile-five-ovelay">
                      <h5>Daziy Millar</h5>
                      <p>PHP Expert</p>
                    </div>
                  </div>
                </li>
                <li class="column-img">
                  <div class="developer-profile-five">
                    <div class="developer-image">
                      <img src="@/assets/img/user/user-08.jpg" alt="Course Instructor" />
                    </div>
                    <div class="profile-five-ovelay">
                      <h5>Daziy Millar</h5>
                      <p>PHP Expert</p>
                    </div>
                  </div>
                </li>
                <li class="column-img">
                  <div class="developer-profile-five">
                    <div class="developer-image">
                      <img src="@/assets/img/user/user-09.jpg" alt="Course Instructor" />
                    </div>
                    <div class="profile-five-ovelay">
                      <h5>Daziy Millar</h5>
                      <p>PHP Expert</p>
                    </div>
                  </div>
                </li>
                <li class="column-img">
                  <div class="developer-profile-five">
                    <div class="developer-image">
                      <img src="@/assets/img/user/user-10.jpg" alt="Course Instructor" />
                    </div>
                    <div class="profile-five-ovelay">
                      <h5>Daziy Millar</h5>
                      <p>PHP Expert</p>
                    </div>
                  </div>
                </li>
                <li class="column-img">
                  <div class="developer-profile-five">
                    <div class="developer-image">
                      <img src="@/assets/img/user/user-11.jpg" alt="Course Instructor" />
                    </div>
                    <div class="profile-five-ovelay">
                      <h5>Daziy Millar</h5>
                      <p>PHP Expert</p>
                    </div>
                  </div>
                </li>
                <li class="column-img">
                  <div class="developer-profile-five">
                    <div class="developer-image">
                      <img src="@/assets/img/user/user-12.jpg" alt="Course Instructor" />
                    </div>
                    <div class="profile-five-ovelay">
                      <h5>Daziy Millar</h5>
                      <p>PHP Expert</p>
                    </div>
                  </div>
                </li>
                <li class="column-img">
                  <div class="developer-profile-five">
                    <div class="developer-image">
                      <img src="@/assets/img/user/user-13.jpg" alt="Course Instructor" />
                    </div>
                    <div class="profile-five-ovelay">
                      <h5>Daziy Millar</h5>
                      <p>PHP Expert</p>
                    </div>
                  </div>
                </li>
                <li class="column-img">
                  <div class="developer-profile-five">
                    <div class="developer-image">
                      <img src="@/assets/img/user/user-14.jpg" alt="Course Instructor" />
                    </div>
                    <div class="profile-five-ovelay">
                      <h5>Daziy Millar</h5>
                      <p>PHP Expert</p>
                    </div>
                  </div>
                </li>
                <li class="column-img">
                  <div class="developer-profile-five">
                    <div class="developer-image">
                      <img src="@/assets/img/user/user-15.jpg" alt="Course Instructor" />
                    </div>
                    <div class="profile-five-ovelay">
                      <h5>Daziy Millar</h5>
                      <p>PHP Expert</p>
                    </div>
                  </div>
                </li>
                <li class="column-img">
                  <div class="developer-profile-five">
                    <div class="developer-image">
                      <img src="@/assets/img/user/user-16.jpg" alt="Course Instructor" />
                    </div>
                    <div class="profile-five-ovelay">
                      <h5>Daziy Millar</h5>
                      <p>PHP Expert</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="instructor-vector-right">
              <img src="@/assets/img/bg/instructor-vector-right.svg" alt="Img" />
            </div>
          </div>
        </div>
        <div class="col-lg-6" data-aos="fade-down">
          <div class="experienced-five-sub">
            <div class="header-five-title header-five-title-inner">
              <h2 class="ex-five-title">Experienced Course Instructor</h2>
            </div>
            <div class="career-five-content">
              <p class="ex-five-content">
                An award-winning course management system (CMS) or program is typically
                recognized for its exceptional quality, innovation, and effectiveness in
                helping both instructors and students succeed. Here's a breakdown of what
                makes a course management program stand out, along with examples of course
                topics and instructors that could be part of such a system.
              </p>
            </div>
            <a href="instructor-list.html" class="btn btn-secondary btn-md"
              >Register Now</a
            >
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Experienced Course Five -->
</template>
